import { gql } from '__generated__';

export default gql(`
  mutation Refund($input: RefundInput!) {
    refund(input: $input) {
      id
      status
    }
  }
`);
